import React from 'react';
import { cn } from '@/utils';
import { TextContent } from '@/components';

export interface UserCellProps {
  /** User's display name */
  name: string;
  /** User's email or secondary info */
  email?: string;
  /** Additional CSS classes */
  className?: string;
}

/**
 * UserCell Component
 *
 * Displays user information with name and email in a two-line format
 * optimized for table cells, based on the Figma design.
 */
export const UserCell: React.FC<UserCellProps> = ({
  name,
  email,
  className,
}) => {
  return (
    <div className={cn('flex flex-col gap-1 min-w-0', className)}>
      <TextContent
        type="paragraph"
        variant="bodyMedium"
        weight="medium"
        color="neutral-gray-800"
        className="truncate"
        label={name}
      />
      {email && (
        <TextContent
          type="paragraph" 
          variant="bodyMedium"
          color="neutral-gray-700"
          className="truncate"
          label={email}
        />
      )}
    </div>
  );
};

UserCell.displayName = 'UserCell';